
import { Accordion, ActionIcon, Avatar, Badge, Button, Chip, Divider, Grid, Group, Image, Input, Menu, Modal, Paper, Popover, Text, Title, UnstyledButton } from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { showNotification } from '@mantine/notifications';
import moment from 'moment';
import React, { useRef } from 'react';
import { FaEdit, FaMinusSquare, FaPaperPlane, FaPencilAlt } from 'react-icons/fa';
import InputField, { InputFieldTypes } from '../components/input_field';
import PaymentMethodForm, { PaymentMethodFormHandle } from '../components/payments/payment_method.form';
import PlanForm, { PlanFormHandle } from '../components/payments/plan.form';
import { useAuth } from '../contexts/auth.context';
import { UPDATE_SELF_COMPANY } from '../services/companies';
import { IMPORT_FILE, SAVE_IMAGE } from '../services/files';
import { SAVE_PAYMENT_METHOD } from '../services/payments';
import { GET_USER_DATA, SAVE_KEYWORDS, SAVE_TAGS } from '../services/users';

export default function UsersPage(){
    const [user, setUser] = React.useState(null);
    const [company, setCompany] = React.useState(null);
    const [updatingImage, setUpdatingImage] = React.useState(null);
    const [keywordInput, setKeywordInput] = React.useState("");
    const [tagInput, setTagInput] = React.useState("");
    const [loadingSaveKeyword, setLoadingSaveKeyword] = React.useState(false);
    const [loadingSaveTag, setLoadingSaveTag] = React.useState(false);
    const [loadingUpdateImage, setLoadingUpdateImage] = React.useState(false);
    const [loadingImport, setLoadingImport] = React.useState(false);
    const [notificationsConfigs, setNotificationsConfigs] = React.useState([
        {id: 1, enabled: true}
    ]);

    const isMobile = useMediaQuery('(max-width: 900px)');
    
    const [importData, setImportData] = React.useState({
        origin: "",
        files: [],
    });
    
    const [openImport, openImportHandler] = useDisclosure(false);
    const [changeCompanyImage, changeCompanyImageHandler] = useDisclosure(false);

    const { role, planData } = useAuth();

    const [openPlan, handlersPlan] = useDisclosure(false);
    const [openPaymentMethod, handlersPM] = useDisclosure(false);

    const paymentMethodFormRef = useRef<PaymentMethodFormHandle>(null);
    const planFormRef = useRef<PlanFormHandle>(null);

    const saveKeyword = e => {
        e.preventDefault();

        if(keywordInput.replace(/ /g, "").length >= 3){
            const ks = [ ...(company?.keywords || []), keywordInput ];
            setLoadingSaveKeyword(true);
            setKeywordInput("")
            SAVE_KEYWORDS(ks)
            .then(res => {
                setLoadingSaveKeyword(false);
                setCompany(c => ({...c, keywords: ks}))
            })
            .catch(err => {
                setLoadingSaveKeyword(false);
                showNotification({title: "Ops.", message: err.message, color: 'red'})
            })
        }else{
            showNotification({title: "Ops", message: "Informe pelo menos 3 caracteres"})
        }
    }
    
    const saveTag = e => {
        e.preventDefault();

        if(tagInput.replace(/ /g, "").length >= 3){
            const ks = [ ...(company?.tags || []), tagInput ];
            setLoadingSaveTag(true);
            setTagInput("")
            SAVE_TAGS(ks)
            .then(res => {
                setLoadingSaveTag(false);
                setCompany(c => ({...c, tags: ks}))
            })
            .catch(err => {
                setLoadingSaveTag(false);
                showNotification({title: "Ops.", message: err.message, color: 'red'})
            })
        }else{
            showNotification({title: "Ops", message: "Informe pelo menos 3 caracteres"})
        }
    }
    
    const removeKeyword = keyword => {
        const oldValue = (company?.keywords || []);
        const ks = oldValue.filter(k => k !== keyword);
        setCompany(c => ({...c, keywords: ks}))

        SAVE_KEYWORDS(ks)
        .then(res => {})
        .catch(err => {
            setCompany(c => ({...c, keywords: oldValue}))
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }
    
    const removeTag = tag => {
        const oldValue = (company?.tags || []);
        const ks = oldValue.filter(k => k !== tag);
        setCompany(c => ({...c, tags: ks}))

        SAVE_TAGS(ks)
        .then(res => {})
        .catch(err => {
            setCompany(c => ({...c, tags: oldValue}))
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }
    
    const importFile = () => {
        setLoadingImport(true)

        const formData = new FormData();
        formData.append(`file`, importData.files[0]);
        formData.append(`origin`, importData.origin);
        
        IMPORT_FILE(formData)
        .then(() => {
            openImportHandler.close();
            setLoadingImport(false);
        })
        .catch(err => {
            setLoadingImport(false);
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }

    const savePaymentMethod = () => {
        const {paymentType, data} = paymentMethodFormRef.current.getData();
        
        SAVE_PAYMENT_METHOD(paymentType, data)
        .then(res => {
            handlersPM.close();
        })
        .catch(err => {
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }

    const disableNotificationConfig = (notificationConfigId, enabled) => {
        const previous = notificationsConfigs
        setNotificationsConfigs(ncs => ncs.map(nc => nc.id == notificationConfigId ? {...nc, enabled} : nc))
        
        // SAVE_PAYMENT_METHOD(paymentType, data)
        // .then(res => {})
        // .catch(err => {
        //     setNotificationsConfigs(previous);
        //     showNotification({title: "Ops.", message: err.message, color: 'red'})
        // })
    }

    const saveImage = (file) => {
        setLoadingUpdateImage(true)
        
        const formData = new FormData();
        formData.append(`file`, file[0]);
        
        SAVE_IMAGE(formData)
        .then(({url: image}) => {
            UPDATE_SELF_COMPANY({image})
            .then(() => {
                setLoadingUpdateImage(false)
                setCompany(c => ({...c, image}))
                changeCompanyImageHandler.close()
            })
            .catch(err => {
                setLoadingUpdateImage(false)
                showNotification({title: "Ops.", message: err.message, color: 'red'})
            })
        })
        .catch(err => {
            setLoadingUpdateImage(false)
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }

    React.useEffect(() => {
        GET_USER_DATA()
        .then(({user, company}) => {
            setUser(user)
            setCompany(company)
        })
        .catch(err => {
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }, [])

    return <>
        <Grid>
            <Grid.Col md={8} sm={12}>
                {role && <Paper p="md" mb="md">
                    <Badge mb="md" color="blue">Empresa</Badge>

                    <Group>
                        <Popover
                            onClose={changeCompanyImageHandler.close}
                            opened={changeCompanyImage}
                            position={isMobile ? "top" : "left"}
                        >
                            <Popover.Target>
                                <div style={{position: 'relative', cursor: 'pointer'}} onClick={changeCompanyImageHandler.open}>
                                    <Avatar src={company?.image} size={80} color="gray" style={{border: '1px solid #EFEFEF'}} />

                                    <div style={{position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', bottom: -10, right: -10, borderRadius: 20, background: '#FFFFFF', border: '1px solid #AAAAAA', padding: 5}}>
                                        <FaPencilAlt color="#6a6a6a" size={12} />
                                    </div>
                                </div>
                            </Popover.Target>
                            <Popover.Dropdown>
                                <InputField
                                    type={InputFieldTypes.IMAGE}
                                    value={updatingImage?.changed || updatingImage?.url}
                                    name="file"
                                    loading={loadingUpdateImage}
                                    onChange={({file}) => { saveImage(file); }}
                                />
                            </Popover.Dropdown>
                        </Popover>

                        <Title order={2}>{company?.name}</Title>
                    </Group>    
                    
                    <Divider mt="md" mb="md" />

                    <Accordion>
                        <Accordion.Item value="keywords">
                            <Accordion.Control>Palavras-chaves</Accordion.Control>
                            <Accordion.Panel>
                                <div>
                                    <form onSubmit={saveKeyword}>
                                        <Input.Wrapper
                                            id="keyword-input"
                                            label="Palavras chaves"
                                            description="Insira uma palavra-chave para monitorar atividades"
                                            >
                                            <Input
                                                id="keyword-input"
                                                placeholder="Palavra-chave"
                                                value={keywordInput}
                                                onChange={e => setKeywordInput(e.target.value)}
                                                rightSection={
                                                    <ActionIcon loading={loadingSaveKeyword} type='submit' variant='light'>
                                                        <FaPaperPlane />
                                                    </ActionIcon>
                                                }
                                            />
                                        </Input.Wrapper>
                                    </form>

                                    {(company?.keywords || []).map(c => <Badge
                                        color="yellow"
                                        mr="sm"
                                        mt="sm"
                                        size='lg'
                                        rightSection={<ActionIcon onClick={() => removeKeyword(c)} variant="light"><FaMinusSquare/></ActionIcon>}
                                    >{c}</Badge>)}
                                </div>
                            </Accordion.Panel>
                        </Accordion.Item>

                        {/* <Accordion.Item value="notifications">
                            <Accordion.Control>Notificações</Accordion.Control>
                            <Accordion.Panel>
                                {notificationsConfigs.map(nc => <Paper shadow="xs" style={{flexDirection: 'row', display: 'flex', padding: 10}}>
                                        <div style={{flex: 1, opacity: !nc.enabled ? 0.1 : 1}}>
                                            
                                        </div>
                                        <div>
                                            <Chip onClick={() => disableNotificationConfig(nc.id, !nc.enabled)} checked={nc.enabled}>{nc.enabled ? 'Ativo' : 'Desativado'}</Chip>
                                        </div>
                                    </Paper>
                                )}
                            </Accordion.Panel>
                        </Accordion.Item> */}

                        <Accordion.Item value="ranking">
                            <Accordion.Control>Tags</Accordion.Control>
                            <Accordion.Panel>
                                <div>
                                    <form onSubmit={saveTag}>
                                        <Input.Wrapper
                                            id="tag-input"
                                            >
                                            <Input
                                                id="tag-input"
                                                placeholder="Tag"
                                                value={tagInput}
                                                onChange={e => setTagInput(e.target.value)}
                                                rightSection={
                                                    <ActionIcon loading={loadingSaveTag} type='submit' variant='light'>
                                                        <FaPaperPlane />
                                                    </ActionIcon>
                                                }
                                            />
                                        </Input.Wrapper>
                                    </form>

                                    {(company?.tags || []).map(c => <Badge
                                        color="yellow"
                                        mr="sm"
                                        mt="sm"
                                        size='lg'
                                        rightSection={<ActionIcon onClick={() => removeTag(c)} variant="light"><FaMinusSquare/></ActionIcon>}
                                    >{c}</Badge>)}
                                </div>
                            </Accordion.Panel>
                        </Accordion.Item>
                    </Accordion>

                    <Divider mt="lg" mb="lg" />

                    <div style={{textAlign: 'right'}}>
                        <Popover
                            onClose={openImportHandler.close}
                            opened={openImport}
                            position={isMobile ? "top" : "left"}
                        >
                            <Popover.Target>
                                <Button
                                        onClick={openImportHandler.open}
                                        variant='outline'
                                        color="blue"
                                    >Importar Dados</Button>
                            </Popover.Target>
                            <Popover.Dropdown>
                                <div>
                                    <InputField
                                        mb="md"
                                        type={InputFieldTypes.SELECT}
                                        value={importData.origin}
                                        title="Origem"
                                        options={[
                                            {label: "Sigalei", value: "sigalei"},
                                            {label: "Inteligov", value: "inteligov"},
                                        ]}
                                        name="origin"
                                        onChange={({origin}) => setImportData(id => ({...id, origin}))}
                                    />

                                    <InputField
                                        type={InputFieldTypes.EXCEL}
                                        // value={importData.file}
                                        name="files"
                                        onChange={({files}) => {
                                            setImportData(id => ({...id, files}))
                                        }}
                                    />

                                    <Button
                                        mt="md"
                                        onClick={importFile}
                                        disabled={!importData.origin || importData.files.length === 0}
                                        loading={loadingImport}
                                    >Salvar</Button>
                                </div>
                            </Popover.Dropdown>
                        </Popover>
                    </div>
                </Paper>}

                <Paper p="md" mb="md" shadow="md">
                    <Badge mb="md" color="blue">Usuário</Badge>
                    <Group>
                        <Avatar src={user?.image} size={80} color="gray"  style={{border: '1px solid #EFEFEF'}} />
                        <Title order={2}>{user?.name}</Title>
                    </Group>
                    <Divider mt="md" mb="md" />
                </Paper>
            </Grid.Col>

            {role && false && <Grid.Col md={4} sm={12}>
                <Paper p="md" mb="md" shadow="md">
                    <Title order={2}>Plano: {planData?.plan?.plan?.title || "Nenhum"}</Title>
                    <Text mt="sm">Válido até {moment(planData?.valid_until).format("DD/MM/YYYY")}</Text>
                    <Group mt="sm">
                        <Text style={{flex: 1}}>Forma de pagamento: {planData?.payment_method?.title || 'Nenhuma'}</Text>
                        <Menu>
                            <Menu.Target>
                                <ActionIcon color="blue" variant="outline"><FaPencilAlt /></ActionIcon>
                            </Menu.Target>
                            <Menu.Dropdown>
                                <Menu.Item onClick={handlersPlan.toggle}>Alterar plano</Menu.Item>
                                <Menu.Item onClick={handlersPM.toggle}>Alterar forma de pagamento</Menu.Item>
                            </Menu.Dropdown>
                        </Menu>
                    </Group>
                </Paper>
            </Grid.Col>}
        </Grid>

        <Modal
            opened={openPlan}
            size="lg"
            onClose={handlersPlan.close}
        >
            <PlanForm
                ref={planFormRef}
            />

            <Group style={{justifyContent: 'right'}} mt="lg">
                <Button variant='outline' onClick={handlersPlan.close}>Cancelar</Button>
                <Button>Alterar</Button>
            </Group>
        </Modal>
        
        <Modal
            opened={openPaymentMethod}
            onClose={handlersPM.close}
            size="lg"
            title="Alterar Forma de Pagamento"
        >
            <PaymentMethodForm
                ref={paymentMethodFormRef}
            />

            <Group style={{justifyContent: 'right'}} mt="lg">
                <Button variant='outline' onClick={handlersPM.close}>Cancelar</Button>
                <Button onClick={savePaymentMethod}>Salvar</Button>
            </Group>
        </Modal>
    </>
}
